export const billing = {
  read(idOrOptions) {
    return $.getJSON(AdminRoutes.adminBillingPath(Object.assign({}, idOrOptions, {format: 'json'})));
  },

  showAddressAlert() {
    return $.getJSON(AdminRoutes.showAddressAlertAdminBillingPath({format: 'json'}));
  },

  dismissAddressAlert(data = {}) {
    return $.post(AdminRoutes.dismissAddressAlertAdminBillingPath(), data);
  },
}